import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
    name: 'printSlice',
    initialState: {
        isRequesting: false,
        error: null,
        data: undefined,
        total: 0,
        searchCriteria: {},
    },
    reducers: {
        get_print_aggregate_payment_statistics: (state, action) => {
            return {
                ...state,
                isRequesting: true,
                error: null,
                searchCriteria: { ...action.payload },
            };
        },
        get_print_aggregate_payment_statistics_succeed: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                error: null,
                data: action.payload
            };
        },
        get_print_aggregate_payment_statistics_failed: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                error: action.payload.error,
                data: undefined,
            };
        },
        get_print_staff_payment_statistics: (state, action) => {
            return {
                ...state,
                isRequesting: true,
                error: null,
                searchCriteria: { ...action.payload },
            };
        },
        get_print_staff_payment_statistics_succeed: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                error: null,
                data: action.payload          
            };
        },
        get_print_staff_payment_statistics_failed: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                error: action.payload.error,
                data: undefined,
            };
        },
        reset_data: (state) => {
            return {
                ...state,
                isRequesting: false,
                error: null,
                data: undefined,
                total: 0,
                searchCriteria: {},
            };
        },
    },
});

export const { reducer, actions } = slice;

export default reducer;
